import { Box, Stack, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';

import CompletedReportsIcon from '../../../../assets/svg/dashboardCompletedReportsIcon.svg';

interface CompletedReportProps {
  value: number;
}
const CompletedReport = ({ value }: CompletedReportProps) => {
  return (
    <Stack padding='20px'>
      <Stack
        direction='row'
        alignItems='center'
        spacing={1}
        paddingBottom='10px'
      >
        <Box
          component='img'
          src={CompletedReportsIcon}
          width={24}
          height={24}
        />
        <Typography
          sx={{
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: 500,
            lineHeight: '125%',
            paddingTop: '5px',
          }}
        >
          <FormattedMessage defaultMessage='Completed Reports' />
        </Typography>
      </Stack>
      <Typography
        sx={{
          fontSize: '28px',
          fontStyle: 'normal',
          fontWeight: 500,
          lineHeight: '125%',
        }}
      >
        {value}
      </Typography>
      <Typography
        sx={{
          fontSize: '12px',
          fontStyle: 'normal',
          fontWeight: 400,
          lineHeight: '125%',
          color: '#878787',
        }}
      >
        <FormattedMessage defaultMessage='Resolved case' />
      </Typography>
    </Stack>
  );
};

export default CompletedReport;
